<template>
  <div ref="container">
    <a-modal
      :title="title"
      :width="380"
      :visible="visible"
      :getContainer="() => $refs.container"
      :maskStyle="{'top':'93px','left':'154px'}"
      :mask="isDesktop()"
      :maskClosable="false"
      @cancel="handleCancel"
      style="top:100px;">
      <a-spin :spinning="loading">
        <div v-if="qrData" class="qr-wrap">
          <div class="qr-table">{{ qrData.tableName }}</div>
          <img class="qr-img" :src="'data:image/png;base64,' + qrData.qrBase64" alt="桌码二维码" />
          <div class="qr-store">{{ qrData.storeName }}</div>
          <div class="qr-type-tip">{{ typeTip }}</div>
          <a-radio-group v-model="qrFormat" size="small" @change="handleFormatChange" class="qr-format">
            <a-radio-button value="qr">普通二维码</a-radio-button>
            <a-radio-button value="wxacode">小程序码</a-radio-button>
          </a-radio-group>
          <div class="qr-btns">
            <a-button type="primary" icon="download" @click="handleDownload">下载二维码</a-button>
            <a-button style="margin-left: 8px" @click="handleCancel">关闭</a-button>
          </div>
        </div>
      </a-spin>
    </a-modal>
  </div>
</template>
<script>
import { tableQr, tableWxacode } from '@/api/plugin/dining'
import { mixinDevice } from '@/utils/mixin'

export default {
  name: 'DiningTableQrModal',
  mixins: [mixinDevice],
  data() {
    return {
      title: '桌码二维码',
      visible: false,
      loading: false,
      qrData: null,
      recordId: null,
      qrFormat: 'qr'
    }
  },
  computed: {
    typeTip() {
      if (!this.qrData) { return '' }
      if (this.qrFormat === 'wxacode') { return '微信扫码直达小程序点餐页' }
      return this.qrData.qrType === 'url' ? '已配置直达域名：微信扫码直达点餐页' : '未配置扫码直达域名：小程序内扫码识别'
    }
  },
  methods: {
    // 后端契约：GET /table/{id}/qr → {qrContent, qrBase64, qrType, tableName, storeName}
    //          GET /table/{id}/wxacode → {qrBase64, qrType:'wxacode', tableName, storeName}（菊花码，需 AppSecret）
    show(record) {
      this.qrData = null
      this.recordId = record.id
      this.qrFormat = 'qr'
      this.visible = true
      this.loadQr('qr')
    },
    loadQr(format) {
      this.loading = true
      const req = format === 'wxacode' ? tableWxacode(this.recordId) : tableQr(this.recordId)
      req.then(res => {
        if (res.code === 200) {
          this.qrData = res.data
        } else {
          this.$message.warning(res.message)
          // 菊花码失败（如未配 AppSecret）回退普通码展示
          if (format === 'wxacode' && this.qrFormat !== 'qr') {
            this.qrFormat = 'qr'
            this.loadQr('qr')
          }
        }
      }).finally(() => {
        this.loading = false
      })
    },
    handleFormatChange(e) {
      this.loadQr(e.target.value)
    },
    handleDownload() {
      if (!this.qrData || !this.qrData.qrBase64) {
        return
      }
      const prefix = this.qrFormat === 'wxacode' ? '桌台小程序码-' : '桌码-'
      const link = document.createElement('a')
      link.href = 'data:image/png;base64,' + this.qrData.qrBase64
      link.download = prefix + (this.qrData.tableName || '') + '.png'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    handleCancel() {
      this.close()
    },
    close() {
      this.$emit('close')
      this.visible = false
    }
  }
}
</script>
<style scoped>
.qr-wrap {
  text-align: center;
  padding: 8px 0 4px;
}
.qr-table {
  font-size: 18px;
  font-weight: 600;
  color: #222;
}
.qr-img {
  width: 240px;
  height: 240px;
  margin-top: 12px;
}
.qr-store {
  font-size: 13px;
  color: #999;
  margin-top: 8px;
}
.qr-type-tip {
  font-size: 12px;
  color: #1890ff;
  margin-top: 4px;
}
.qr-btns {
  margin-top: 16px;
}
.qr-format {
  text-align: center;
  margin-top: 12px;
}
</style>
